/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react'
// import IconChevronDown from '../../../images/icon/chevron-down.svg';
// import FilterIcon from '../../../images/icon/filter-priority-icon.svg';
// import SearchIcon from '../../../images/icon/search-icon.png';
// import _ from 'lodash';
import styled from 'styled-components';
import Svg from "_assets/svg";
const Icon = styled.img``;
const ButtonProject = styled.div`
  /* Rectangle 99 */
  // margin: 8px;

  // padding: 10px;
  display: flex;
  // flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background: #f8f8f9;
  opacity: 0.8;
  border: 1px solid #d8dce1;
  box-sizing: border-box;
  border-radius: 8px;
  &:focus{
    outline: none;
  }

  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  cursor:pointer;
`;

const Button = styled.button`
    background: transparent;
    border: 0px;
    padding: 15px 10px;
    text-align: left;
    &:focus{
        outline: none;
    }
    // &:hover{
    //     background: #d5d5d5;
    // }
`

const Wrapper = styled.div`
    position: relative;
    // background: #FFFFFF;
    top: 0px;
    width:100%;
    min-width: 200px;
    min-height: 50px;
    max-height:185px;
    // height:25vh;
    // max-height: 400px;
    overflow: auto;
    // left: 6px;
    z-index: 88;
    border: #d5d5d5 solid 1px;
    border-radius: 10px;
    flex-direction: column;
    flex: 1;
    display: flex;
   
}
`;

function MultipleSelectStatus({title, loading, dataFilt,validation,setFinalStatus, setDataStatusAll}) {
    const [dataFilter,setDataFilter]=useState([])
    const [choosedTitle,setChoosedTitle] = useState("Select " + title);
    const [visible,setVisible]=useState(false);
    const [choosen,setChoosen]=useState([]);
    const [checkAll,setCheckAll]=useState(false);
    
    // function handleChange(){
    //     setVisible(false);
    //     onChange(choosen);
    // }
    // useEffect(()=>{
    //     // if(choosen.length==0){
    //     //     setChoosedTitle("All "+title);
    //     //     setCheckAll(true);
    //     // }
    //     onChange(choosen);
    // },[choosen]);
    
    useEffect(()=>{
        let choose=[]
        let newData=dataFilt.map((va)=>{
            choose.push(va.value);
            // va.checked=true;
            return va
        })
        // setChoosen(choose);
        // onChange(choose)
        setDataFilter(newData);
    },[dataFilt]);

    function clearChoosed(){
        setChoosen([]);
    }

    function selectAll(e){
        clearChoosed();
        
        setCheckAll(e.target.checked);
        if(!e.target.checked){
            setChoosedTitle("Choosed One");
        }else{
            setChoosedTitle("All "+title);
        }
      
        
        if (dataFilter.length > 0) {
            let choosed=[];

            const newFilters = dataFilter.map(val => {
                choosed.push(val.value);
                val.checked = e.target.checked
                return val
            })

            if(e.target.checked){
                setChoosen(choosed);
                setFinalStatus(choosed)
                setDataStatusAll(true)
            }
            setDataFilter(newFilters)
        }
    }

    function handleChecked(e,index){
        setCheckAll(false);
        let checkAll=true;
        let choosed=choosen;

        const newFilters = dataFilter.map((val, i) => {
            if (i === index) {
                val.checked = e.target.checked
                if(e.target.checked){
                    choosed.push(val.value);
                }else{
                    let choosedIndex=choosed.findIndex((el)=>el==val.value);
                    if(choosedIndex>-1){
                        choosed.splice(choosedIndex,1);
                    }
                }
            } 
            if(!val.checked){
                checkAll=false
            }
            return val
        })
        setChoosen(choosed);
        setDataFilter(newFilters)
        setFinalStatus(choosed);
        setDataStatusAll(false)

        if(checkAll){
            setCheckAll(checkAll);
            setChoosedTitle("All "+title);
        }else{
            setChoosedTitle(choosed.length+" options")
        }
    }
    
    const container=useRef();

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (container.current && !container.current.contains(event.target)) {
                setVisible(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [container])
    const [search, setSearch] = useState("")
    const handleSearch = (e) => {
        setSearch(e.target.value)
        if (e.target.value) {
            var regex = new RegExp(e.target.value, "gi");
            const newFilters = dataFilter.filter((val) => val.name.match(regex))
            setDataFilter(newFilters)
        } else {
            setDataFilter(dataFilt)
        }
    }



    return (
        <div className="w-full relative" ref={container}>
            <div className='mb-4' style={{position:'relative'}}>
                <label className="margin-bottom-5 h4 margin-right-10">Select Status <span className='startRed'>*</span></label>
                <ButtonProject className="w-auto col-md-6 br-8"  onClick={()=>setVisible(!visible)}>
                  <label className="margin-right-10">{choosedTitle}</label>
                  <Icon src={Svg.chevron_right_2.default} />
                </ButtonProject>
                {visible && 
                <Wrapper className='overflow_custom'>
                    <Button>
                    {dataFilter.length > 0 &&
                    <div>
                        <div className='mb-3 d-flex justify-content-between align-items-center'>
                            <div>Status</div>
                            {/* <div onClick={handleChange}>Apply</div> */}
                        </div>
                        <div className="hover-status ml-1 d-flex align-items-center">
                            <input type="checkbox" onChange={selectAll} checked={checkAll} className='input-status'/>
                            <div className={`text-xsm ms-2 ${checkAll && 'text-custom-6 font-bold'}`}>All</div>
                        </div>
                    </div>
                    }
                    {dataFilter.length > 0 && dataFilter.map((val, i) => (
                        <div key={i} className="hover-status mt-2 d-flex align-items-center flex-nowrap break-all">
                            <input
                                type="checkbox"
                                checked={val.checked}
                                onChange={(e) => handleChecked(e,i)}
                                className='input-status'/>
                            <div className={`text-xsm ms-2 capitalize ${val.checked && 'font-bold text-custom-6'}`}>{val.name}</div>
                        </div>
                    ))}
                    </Button>
                </Wrapper>
                }
            <div className='startRed italic mb-2'>{validation}</div>
            </div>
        </div>
    )
}

export default MultipleSelectStatus;